import { getApiUrl } from '@/config/get-api-url'
import type { NetworkId } from '@/types/network'
import { useChainId } from 'wagmi'

export function useApiUrl() {
	const chainId = useChainId()

	return getApiUrl(chainId as NetworkId)
}
